import React from 'react';

export const Promo = ({ children }: { children: React.ReactNode }): JSX.Element | null => {
    return <>{children}</>;
};
